var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRanking(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.33207 7.93129C1.35041 7.93129 1.3667 7.93129 1.38503 7.92905L3.16118 15H10.001H16.8388L18.6149 7.92905C18.6332 7.92905 18.6495 7.93129 18.6679 7.93129C19.4032 7.93129 20 7.27483 20 6.46602C20 5.65721 19.4032 5.00075 18.6679 5.00075C17.9326 5.00075 17.3358 5.65721 17.3358 6.46602C17.3358 6.62285 17.3582 6.7752 17.401 6.91635L14.1888 8.98208L10.7363 2.68633C11.0948 2.4242 11.3331 1.97386 11.3331 1.46527C11.3331 0.65646 10.7363 0 10.001 0C9.26573 0 8.6689 0.65646 8.6689 1.46527C8.6689 1.9761 8.9052 2.4242 9.26573 2.68633L5.81323 8.98208L2.60108 6.91635C2.64182 6.7752 2.66626 6.62285 2.66626 6.46602C2.66626 5.65721 2.06946 5.00075 1.33415 5.00075C0.596803 5.00075 0 5.65721 0 6.46602C0 7.27483 0.596763 7.93129 1.33207 7.93129Z",
    fill: "#FFB800"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7782 18.5C17.7782 17.6709 17.2612 17 16.6222 17H3.37866C2.7397 17 2.22266 17.6709 2.22266 18.5C2.22266 19.3291 2.7397 20 3.37866 20H16.6222C17.2612 20 17.7782 19.3264 17.7782 18.5Z",
    fill: "#FFB800"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRanking);
export default __webpack_public_path__ + "static/media/Ranking.28e7567a133021a0b685e5b63ab9f161.svg";
export { ForwardRef as ReactComponent };